import { render, staticRenderFns } from "./TheDatosFactura.vue?vue&type=template&id=73d820ab&scoped=true&"
import script from "./TheDatosFactura.vue?vue&type=script&lang=js&"
export * from "./TheDatosFactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d820ab",
  null
  
)

export default component.exports